import { ENavTransparency } from '@features/navigation/typescript';
export const CMS_CONTENT_TYPE = {
  informationCardWithMedia: 'informationCardWithMedia'
};
export const CMS_DOCUMENT_BEHAVIOUR = {
  categoryPage: 'categoryPage',
  accrodionGroup: 'accordionGroup',
  nestedDocument: 'nestedDocument',
  default: 'default'
};
export const CMS_BLOCKS_TRANSPARENCY = {
  header: ENavTransparency.BOTH_TRANSPARENT
};
export const MARGINS_BLOCKS = {
  0: '0px',
  8: '8px',
  16: ['12px', '12px', '16px'],
  24: ['16px', '16px', '24px'],
  40: ['24px', '24px', '24px', '40px'],
  48: ['24px', '24px', '32px', '48px'],
  64: ['32px', '32px', '40px', '64px'],
  80: ['48px', '48px', '64px', '80px'],
  116: ['64px', '64px', '80px', '116px']
};
export const BLANK_VIDEO_OBJECT = {
  desktop: '',
  tablet: '',
  mobile: ''
};
export const INSPIRATIONS_PER_PAGE = 64;